module.exports = __webpack_public_path__ + "img/Handfunkgerät_digital.21617b4e.svg";